import React, { useEffect } from "react";
import Navbar from "./Navbar";
import InternetExplain from "./InternetExplain";
import AOS from "aos";
import "aos/dist/aos.css"; // Importer les styles de AOS
import Teams from "./Team";
import Solutions from "./Solution";
import Footer from "./Footer";

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialiser AOS avec une durée d'animation de 1000ms
  }, []);

  const scrollToElement = (text) => {
    document.getElementById(text).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-gradient-to-b from-black to-blue-800 min-h-screen text-white">
      <Navbar />

      {/* Section Accueil */}
      <section
        id="accueil"
        className="h-screen relative bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/home.jpg')" }}
      >
        <div className="flex items-center justify-center h-full bg-black bg-opacity-50">
          <div className="text-center text-white">
            <h1
              className="text-5xl md:text-6xl font-bold mb-6"
              data-aos="fade-up"
            >
              Bienvenue chez WebMinds
            </h1>
            <p
              className="text-lg md:text-2xl"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Développons ensemble des solutions web et mobiles innovantes.
            </p>
          </div>
        </div>
        <div
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white cursor-pointer animate-bounce"
          onClick={() => scrollToElement("why-site")}
        >
          <i className="fas fa-chevron-down fa-3x"></i>
        </div>
      </section>
      <InternetExplain />

      {/* Section Services */}
      <section id="services" className="py-24 bg-gray-800">
        <div className="container mx-auto px-4 text-center">
          <h2
            className="text-4xl md:text-5xl font-extrabold mb-12 text-blue-100"
            data-aos="fade-up"
          >
            Nos Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Service 1 */}
            <div
              className="bg-gray-700 p-6 rounded-lg shadow-lg border-2 border-blue-500 hover:border-blue-400 transition-colors duration-300"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <i className="fas fa-laptop-code fa-3x mb-4 text-blue-500"></i>
              <h3 className="text-xl font-semibold mb-2 text-blue-100">
                Développement Web
              </h3>
              <p className="text-gray-300 mb-4">
                Création de sites web personnalisés et performants pour répondre
                à vos besoins spécifiques.
              </p>
              <a
                href="/site-vitrine"
                className="inline-block px-6 py-3 bg-blue-600 text-white text-lg font-medium rounded-md hover:bg-blue-500 transition-colors duration-300"
              >
                En savoir plus
              </a>
            </div>
            {/* Service 2 */}
            <div
              className="bg-gray-700 p-6 rounded-lg shadow-lg border-2 border-green-500 hover:border-green-400 transition-colors duration-300"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <i className="fas fa-mobile-alt fa-3x mb-4 text-green-500"></i>
              <h3 className="text-xl font-semibold mb-2 text-blue-100">
                Développement Mobile
              </h3>
              <p className="text-gray-300 mb-4">
                Applications mobiles innovantes pour iOS et Android avec une
                expérience utilisateur optimale.
              </p>
              <a
                href="/application-mobile"
                className="inline-block px-6 py-3 bg-green-600 text-white text-lg font-medium rounded-md hover:bg-green-500 transition-colors duration-300"
              >
                En savoir plus
              </a>
            </div>
            {/* Service 3 */}
            <div
              className="bg-gray-700 p-6 rounded-lg shadow-lg border-2 border-yellow-500 hover:border-yellow-400 transition-colors duration-300"
              data-aos="fade-up"
              data-aos-delay="500"
            >
              <i className="fas fa-search fa-3x mb-4 text-yellow-500"></i>
              <h3 className="text-xl font-semibold mb-2 text-blue-100">
                SEO & Marketing
              </h3>
              <p className="text-gray-300 mb-4">
                Stratégies de SEO et de marketing digital pour améliorer la
                visibilité de votre site et attirer plus de clients.
              </p>
              <a
                href="/seo"
                className="inline-block px-6 py-3 bg-yellow-600 text-white text-lg font-medium rounded-md hover:bg-yellow-500 transition-colors duration-300"
              >
                En savoir plus
              </a>
            </div>
            {/* Service 4 */}
            <div
              className="bg-gray-700 p-6 rounded-lg shadow-lg border-2 border-red-500 hover:border-red-400 transition-colors duration-300"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <i className="fas fa-share-alt fa-3x mb-4 text-red-500"></i>
              <h3 className="text-xl font-semibold mb-2 text-blue-100">
                Réseaux sociaux
              </h3>
              <p className="text-gray-300 mb-4">
                Gestion et optimisation de vos profils sociaux pour améliorer
                votre présence en ligne.
              </p>
              <a
                href="/reseau-sociaux"
                className="inline-block px-6 py-3 bg-red-600 text-white text-lg font-medium rounded-md hover:bg-red-500 transition-colors duration-300"
              >
                En savoir plus
              </a>
            </div>
            {/* Service 5 */}
            <div
              className="bg-gray-700 p-6 rounded-lg shadow-lg border-2 border-purple-500 hover:border-purple-400 transition-colors duration-300"
              data-aos="fade-up"
              data-aos-delay="700"
            >
              <i className="fas fa-paint-brush fa-3x mb-4 text-purple-500"></i>
              <h3 className="text-xl font-semibold mb-2 text-blue-100">
                Conception Graphique
              </h3>
              <p className="text-gray-300 mb-4">
                Création de visuels impactants pour renforcer votre image de
                marque et attirer l’attention.
              </p>
              <a
                href="/conception-graphique"
                className="inline-block px-6 py-3 bg-purple-600 text-white text-lg font-medium rounded-md hover:bg-purple-500 transition-colors duration-300"
              >
                En savoir plus
              </a>
            </div>
          </div>
        </div>
      </section>

      <Teams />
      <Solutions />

      {/* Section Demande de Devis */}
      <section
        id="devis"
        className="py-24  bg-gray-900"
      >
        <div className="container mx-auto px-4 text-center">
          <h2
            className="text-4xl md:text-5xl font-extrabold mb-6 text-white"
            data-aos="fade-up"
          >
            Vous avez un Projet en Tête ?
          </h2>
          <p
            className="text-lg md:text-xl mb-12 text-gray-100"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Nous serions ravis de discuter de vos idées et de vous proposer un
            devis adapté à vos besoins. Cliquez sur le bouton ci-dessous pour
            nous contacter et obtenir plus d'informations.
          </p>
          <a
            href="/contact"
            className="inline-block px-8 py-4 bg-yellow-500 text-black text-lg font-semibold rounded-md hover:bg-yellow-400 transition-colors duration-300"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            Demandez un devis
          </a>
        </div>
      </section>


      {/* Section Équipe */}
      <Footer />
    </div>
  );
};

export default Home;
